/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  Portfolio story data
  ============================================================

  Kuvien järjestystä ja tiedostoja voidaan vaihtaa täällä
  ilman PortfolioStory-komponentin muokkaamista.
*/

const portfolioStoryItems = [
  {
    id: "01",
    src: "/media/portfolio/portfolio-01.webp",
    translationKey: "one",
  },

  {
    id: "02",
    src: "/media/portfolio/portfolio-02.webp",
    translationKey: "two",
  },

  {
    id: "03",
    src: "/media/portfolio/portfolio-03.webp",
    translationKey: "three",
  },

  {
    id: "04",
    src: "/media/portfolio/portfolio-04.webp",
    translationKey: "four",
  },

  {
    id: "05",
    src: "/media/portfolio/portfolio-05.webp",
    translationKey: "five",
  },
];

export default portfolioStoryItems;
